import { QUERY_KEYS } from 'api/query-keys';
import { useMutation, UseMutationOptions, useQueryClient } from 'react-query';
import { sharedPaymentService } from 'api/services';
import { Site } from 'shared/hooks';
import { PaymentUsersFilters } from './use-payment-users.types';

type BlockUserMutationContext = { site: Site; flexWorkerId: string };
type BlockUserMutationOptions = UseMutationOptions<unknown, Error, BlockUserMutationContext>;

export const useBlockUser = (
  appliedFilters: PaymentUsersFilters,
  options?: BlockUserMutationOptions
) => {
  const mutationFn = async ({ site, flexWorkerId }: BlockUserMutationContext) =>
    await sharedPaymentService.blockUser(site, flexWorkerId);
  const queryClient = useQueryClient();
  const { onSuccess, ...restOptions } = options ?? {};

  return useMutation(mutationFn, {
    onSuccess: async (data, variables, context) => {
      queryClient.invalidateQueries(QUERY_KEYS.paymentUsers(appliedFilters));
      onSuccess && onSuccess(data, variables, context);
    },
    ...restOptions,
  });
};
